import { useAppState } from 'hooks/useAppState';
import { Cache } from 'types/util';

export const useNewSportApplicationsCount = (): Cache<number> => {
  const { newSportApplicationsCount } = useAppState();

  return newSportApplicationsCount;
};
